import Rive from '@rive-app/react-canvas';

import {Stack} from 'shells/layout/stack/stack';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import {EmailSetupStep} from './types';

import styles from './email-settings-setup.module.css';

interface Props {
    currentStep: EmailSetupStep;
    emailAddress: string;
    setEmailAddress: (value: string) => void;
    displayName: string;
    setDisplayName: (value: string) => void;
    onNext: () => void;
    onSave: () => void;
    error: string | null | undefined;
}

export function EmailSettingsSetupStepContent(props: Props) {
    if (props.currentStep === EmailSetupStep.ADD_EMAIL) {
        return (
            <>
                <div className={styles['animation-container']}>
                    <Rive src='/include/rive/inbox/shared-inbox-onboarding.riv' />
                </div>
                <Stack spacing={16} alignItems='center'>
                    <Body
                        isBold={true}
                        useDoyle={true}
                        size='xlarge'
                        color='dark'
                        textAlign='center'
                    >
                        Add a shared email address
                    </Body>
                    <Body textAlign='center'>
                        Set up your shared email address like{' '}
                        <Body isBold={true} color='dark'>
                            sales@
                        </Body>{' '}
                        or{' '}
                        <Body isBold={true} color='dark'>
                            support@company.com
                        </Body>{' '}
                        <br />
                        and use it to forward emails and reply to them with your team.
                    </Body>
                </Stack>
                <div className={styles['text-field-container']}>
                    <TextField
                        value={props.emailAddress}
                        onChange={props.setEmailAddress}
                        placeholder='Enter email address'
                        focusOnMount={true}
                        onEnter={props.onNext}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <div className={styles['animation-container']}>
                <Rive src='/include/rive/inbox/shared-inbox-onboarding-2.riv' />
            </div>
            <Stack spacing={16} alignItems='center'>
                <Body isBold={true} useDoyle={true} size='xlarge' color='dark' textAlign='center'>
                    What’s your sender name?
                </Body>
                <Body textAlign='center'>
                    Pick a friendly name for this email, like{' '}
                    <Body isBold={true} color='dark'>
                        ‘Team Sales’
                    </Body>
                    — this is how it will
                    <br />
                    appear when you send emails from Nutshell.
                </Body>
            </Stack>
            <div className={styles['text-field-container']}>
                <TextField
                    value={props.displayName}
                    onChange={props.setDisplayName}
                    placeholder='Enter sender name'
                    focusOnMount={true}
                    onEnter={props.onSave}
                />
            </div>
            {props.error && (
                <Body color='error' size='small'>
                    {props.error}
                </Body>
            )}
        </>
    );
}
